import {
  useAuthenticator,
  type AuthenticationLevel,
} from '@seek/hirer-auth-react';

import { useRedirectURL } from 'src/App/context/Authentication/useRedirectURL';

interface AuthenticateProp {
  children: React.ReactNode;
  level?: AuthenticationLevel;
}

export const Authenticate: React.FC<AuthenticateProp> = ({
  children,
  level,
}: AuthenticateProp) => {
  const { pathname, search } = useRedirectURL();

  useAuthenticator({
    level,
    canonicalUrl: `${pathname}${search}`,
  });

  return <>{children}</>;
};
